/**
 * @author        quanquan
 * @dateTime      2021-01-04 14:49:11
 * @description   ignore
 */

export default [
  '/',
  '/app-login'
]



// WEBPACK FOOTER //
// ./src/js/module/ps/ignore.js